import { makeStyles } from '@mui/styles';
import type { Theme } from '@mui/material/styles';

export const useStyles = makeStyles<Theme>((theme) => ({
  logo: {
    position: 'relative',
    padding: '15px 25px',
    zIndex: 4,
    margin: '20px 0 0 0',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    textDecoration: 'none',
    color: 'inherit',
  },
  logoImage: {
    width: 35,
    marginRight: theme.spacing(1),
  },
  logoText: {
    fontSize: 18,
  },
}));
